import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import '@/styles/milk-auth.css';

const WORDMARK_BLUE = '/assets/logos/wordmark-blue.png';

export default function GoogleCallbackPage() {
  const { completeGoogleLogin } = useAuth();
  const navigate = useNavigate();
  const ran = useRef(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const state = params.get('state');
    const errParam = params.get('error');

    if (errParam) {
      setError('Sign-in was cancelled. Please try again.');
      setTimeout(() => navigate('/login', { replace: true }), 1800);
      return;
    }
    if (!code) {
      setError('Missing authorization code.');
      setTimeout(() => navigate('/login', { replace: true }), 1800);
      return;
    }

    (async () => {
      try {
        const userData = await completeGoogleLogin(code, state);
        let returnTo = null;
        try { returnTo = sessionStorage.getItem('mk_oauth_return'); sessionStorage.removeItem('mk_oauth_return'); } catch { /* ignore */ }
        if (returnTo) navigate(returnTo, { replace: true });
        else navigate(userData?.onboarding_completed ? '/' : '/onboarding', { replace: true });
      } catch (err) {
        setError(err?.response?.data?.detail || 'Google sign-in failed. Please try again.');
        setTimeout(() => navigate('/login', { replace: true }), 2200);
      }
    })();
  }, [completeGoogleLogin, navigate]);

  return (
    <div className="mlk-auth" data-testid="google-callback-page">
      <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 18, background: '#F4F2EB', padding: 24 }}>
        <img src={WORDMARK_BLUE} alt="Milk" style={{ height: 30, width: 'auto' }} />
        {error ? (
          <p style={{ color: '#B4332E', fontFamily: "'Work Sans', sans-serif", fontSize: 15, textAlign: 'center', maxWidth: 360 }} data-testid="google-callback-error">
            {error}
          </p>
        ) : (
          <>
            <div style={{ width: 28, height: 28, border: '3px solid rgba(33,46,64,.15)', borderTopColor: '#6994C6', borderRadius: '50%', animation: 'mlkspin 0.8s linear infinite' }} />
            <p style={{ color: '#6F6E67', fontFamily: "'Work Sans', sans-serif", fontSize: 15 }}>Signing you in…</p>
          </>
        )}
      </div>
      <style>{`@keyframes mlkspin{to{transform:rotate(360deg)}}`}</style>
    </div>
  );
}
